/** Utilidades de fecha en formato día/mes/año (es-MX). */

/** Fecha ISO ``YYYY-MM-DD`` de hoy en zona horaria México (para SAT y UI). */
export function todayIsoMx() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "America/Mexico_City" });
}

/** Rango por defecto año en curso (MX): 1 de enero → hoy. */
export function currentYearToTodayRangeIso() {
  const today = todayIsoMx();
  const year = today.slice(0, 4);
  return { from: `${year}-01-01`, to: today };
}

/** Convierte ISO calendario a ``Date`` local (medianoche, sin desfase UTC). */
export function isoToLocalDate(iso) {
  if (!iso) return undefined;
  const s = String(iso).slice(0, 10);
  const [y, mo, d] = s.split("-").map((n) => parseInt(n, 10));
  if (!y || !mo || !d) return undefined;
  return new Date(y, mo - 1, d);
}

/** ``Date`` local → ISO ``YYYY-MM-DD`` (solo calendario). */
export function localDateToIso(date) {
  if (!date || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

/** Límite inferior operativo SAT (~5 años, alineado con backend). */
export function satMinDownloadDateIso() {
  const today = isoToLocalDate(todayIsoMx());
  if (!today) return "2000-01-01";
  const min = new Date(today);
  min.setFullYear(min.getFullYear() - 5);
  return localDateToIso(min);
}

/** ``YYYY-MM-DD`` → ``DD/MM/YYYY`` para mostrar en inputs. */
export function isoToMxDisplay(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const [y, mo, d] = s.split("-");
  if (!y || !mo || !d) return "";
  return `${d.padStart(2, "0")}/${mo.padStart(2, "0")}/${y}`;
}

/**
 * Parsea ``DD/MM/YYYY`` (o ``D/M/YYYY``) a ``YYYY-MM-DD``.
 * Acepta también ISO ``YYYY-MM-DD``. Devuelve ``null`` si es inválida.
 */
export function parseMxDateToIso(text) {
  const raw = (text || "").trim();
  if (!raw) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  const m = raw.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const month = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  if (year < 2000 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) {
    return null;
  }
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

/** Alias usado en bitácoras y mensajes de éxito. */
export function formatIsoDateMx(iso) {
  const out = isoToMxDisplay(iso);
  return out || "—";
}

/**
 * Rango ISO ``YYYY-MM-DD`` del mes calendario (MX), con fin acotado a hoy MX.
 */
export function monthIsoRange(year, month) {
  const y = Number(year);
  const m = Number(month);
  if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) {
    return { start: "", end: "" };
  }
  const start = `${y}-${String(m).padStart(2, "0")}-01`;
  const lastDay = new Date(y, m, 0).getDate();
  let end = `${y}-${String(m).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
  const today = todayIsoMx();
  if (end > today) end = today;
  return { start, end };
}
